import {
  alpha,
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { CompanyNotices } from '../../../../../api/theHive/licensedCompanies/types';
import { IconCloseMS } from '../../../../../constants/icons';
import useGeneral from '../../../../../hooks/useGeneral';
import {
  presentNoticeTableHead,
  presentNoticeTableValues,
} from '../Table/presenter';
import {
  StyledCell,
  StyledPagination,
  StyledRow,
  TableCellHeader,
} from '../Table/styles';
import {
  CloseButtonBox,
  CloseIcon,
  DialogContainer,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ActiveNoticesDialogProps {
  handleNavigate: (
    noticeId: number,
    licensedCompanyId: number | undefined
  ) => void;
  tableData: CompanyNotices[];
  page: number;
  totalPages: number;
  setPage: (value: number) => void;
}

export function ActiveNoticesDialog({
  handleNavigate,
  tableData,
  page,
  totalPages,
  setPage,
}: ActiveNoticesDialogProps): JSX.Element {
  const { open, handleClose, handleOpen } = useGeneral();

  return (
    <>
      <OutlinedButton onClick={handleOpen}>descredenciar</OutlinedButton>
      <StyledDialog open={open} onClose={handleClose}>
        <CloseButtonBox>
          <CloseIcon onClick={handleClose}>{IconCloseMS}</CloseIcon>
        </CloseButtonBox>
        <DialogContainer>
          <TextTypography fontWeight={600}>
            Selecione o edital que deseja realizar o descredenciamento
          </TextTypography>
          <Box>
            <TableContainer component={Paper} sx={{ marginTop: '18px' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {presentNoticeTableHead().map((cell) => (
                      <TableCellHeader align="center" key={cell.id}>
                        {cell.label}
                      </TableCellHeader>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tableData.map((element) => (
                    <StyledRow
                      key={element.id}
                      onClick={() =>
                        handleNavigate(element.id, element.notice_company?.id)
                      }
                      sx={(theme) => ({
                        cursor: element.notice_company?.id
                          ? 'pointer'
                          : 'default',
                        '&:hover': element.notice_company?.id
                          ? {
                              backgroundColor: alpha(
                                theme.palette.primary.main,
                                0.1
                              ),
                            }
                          : undefined,
                      })}
                    >
                      {presentNoticeTableValues(element).map((cell) => (
                        <StyledCell key={cell.id} align="center">
                          <Tooltip
                            title={
                              typeof cell.value === 'string' &&
                              cell.value.length > 300
                                ? cell.value
                                : ''
                            }
                          >
                            <Box>{cell.value}</Box>
                          </Tooltip>
                        </StyledCell>
                      ))}
                    </StyledRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <StyledPagination
              page={page}
              count={totalPages}
              onChange={(_, v) => setPage(v)}
            />
          </Box>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
